import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec cloud_computing_tabs p-100">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} className="m-auto text-center">
            <h3 className="h3_head">
              Tech Stack for <span>Web Portal Development</span> Services
            </h3>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/frontend/AngularJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>AngularJs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/frontend/Css.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>CSS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/frontend/HTML.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>HTML</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/frontend/JS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Javascript</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/frontend/Meteor.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Meteor</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/frontend/NextJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>NextJs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/frontend/Reactnative.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>React Js</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/frontend/VueJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Vue Js</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/backend/Go_lan.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Go</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/backend/Java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/backend/MS.Net.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>MS.Net</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/backend/Node.js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Node js</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/backend/Php.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Php</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/backend/python.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Cloud Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/cloud-database/Amazon_DynamoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Amazon_DynamoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/cloud-database/amazon_redshift.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Amazon redshift</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/cloud-database/Azure_SQL_Database.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure SQL Database</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/cloud-database/Google_Clou_Datastore.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud Datastore</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Cloud Web">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/cloud-web/AWS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/cloud-web/Azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/cloud-web/digital_ocean.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Digital Ocean</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/cloud-web/Google_Cloud_Platform.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud Platform</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/cloud-web/reckspace.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Reckspace</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Database Storage">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/database-web/Azure_SQL_Database.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure SQL Database</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/database-web/cassandra.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Cassandra</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/database-web/my_sql.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>My SQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/database-web/Oracle.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Oracle</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/database-web/PostgreSQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/database-web/SQL_server.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>SQL Server</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="Mobile Platform">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/mobile/Android.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Android</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/mobile/Cordova.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Cordova</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/mobile/Flutter.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Flutter</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/mobile/Ionic.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Ionic</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/mobile/Reactnative.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>React Native</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/mobile/Xamarin.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Xamarin</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="7" title="Platform Web">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/platform-web/Joomla.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Joomla</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/platform-web/Magento.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Magento</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/platform-web/SalesForce.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>SalesForce</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/platform-web/SharePOint.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>SharePoint</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/platform-web/Wordpress.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Wordpress</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="8" title="Real Time Data Processing">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/real-time-data/amazon_kinesis.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Amazon kinesis</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/real-time-data/apche_storm.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Apache storm</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/real-time-data/azure_event_hub.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure Event Hub</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/real-time-data/flink.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Flink</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web-portal/real-time-data/kafk_sreams.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Kafka Streams</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
